import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { prepareCustomer } from "../helpers/compliance";
import useCustomer from "./useCustomer";

const useSuspects = () => {
  const methods = useFormContext();
  const { watch, setValue } = methods;
  const customerIds = watch("customerIds");
  const { suspectsTable } = useSelector((state) =>
    SuspiciousActivityAction.getStatePath(state),
  );

  const { onSelectCustomer, onNewCustomer, onEditCustomer, onRemoveCustomer } =
    useCustomer();

  const handleExists = (response) => {
    SuspiciousActivityAction.dispatch({
      suspectsTable: [
        ...suspectsTable,
        ...response.data.map((customer) => prepareCustomer(customer)),
      ],
    });
    setValue(
      "customerIds",
      [...customerIds, ...response.data.map((customer) => customer.id)],
      { shouldValidate: true },
    );
  };

  const onSelect = (customerId) => onSelectCustomer(customerId);

  const handleNewSuspect = (customer) => onNewCustomer(customer);

  const handleEditSuspect = (customer) => onEditCustomer(customer);

  const handleRemoveSuspect = (customer) => onRemoveCustomer(customer);

  return {
    onSelect,
    suspectsTable,
    handleExists,
    handleNewSuspect,
    handleEditSuspect,
    handleRemoveSuspect,
  };
};

export default useSuspects;
